module.exports = __webpack_public_path__ + "img/智慧屏场景_线下大屏.6f9b0d84.png";